<template>
  <div>
    <selector-field
      class="m3p-select m3p-form__strong"
      :name="fieldName"
      :id="fieldName"
      :options="selectiveCityList"
      :validator="validator"
      :dispatcher="dispatcher"
    >
      <template #select="props">
        <option :value="null">市区町村（任意）</option>
        <option
          v-for="item in props.options"
          :value="item.text"
          :key="item.value"
          >{{ item.text }}</option
        >
      </template>
    </selector-field>
    <error-message :name="fieldName" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import SelectorField from '@component_path/pages/common/form/element/select';
import { useAddressField } from '@component_path/inquiry_form_common_module/custom_hook/Address';

const props = defineProps({
  selectiveCityList: {
    type: Array,
    required: true
  }
});
const { validator, fieldName } = useAddressField(false);
const dispatcher = ref('positionInquiryMail/setAddress');
</script>
